import { VarType } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonVariant, Input, RadioButtons } from "@swivl-mono/ui";
import { useState } from "react";

import ModalModel from "../../../../../Models/Modal/Modal.Model";

interface Props {
  createNewVariable: (v: NewVariableState) => void;
}

export interface NewVariableState {
  type: VarType;
  key: string;
  displayName: string;
  description: string;
  defaultValue: string;
}

export const AddVariableModal = (props: Props) => {
  const [state, setState] = useState<NewVariableState>({ type: VarType.Location, key: "", displayName: "", description: "", defaultValue: "" });

  const saveClicked = () => {
    if (!state.key || state.key.length < 3) {
      alert("Key is required.");
      return;
    }
    if (!state.displayName || state.displayName.length < 3) {
      alert("Display Name is required.");
      return;
    }

    props.createNewVariable(state);
  };

  return (
    <div className="AddVariableModal mb-10 flex flex-col rounded-md bg-white p-5">
      <h3>Add New Variable</h3>
      <label>{state.type === "UserVar" ? "UserVarKey:" : "LocationVarKey:"}</label>
      <b className="mb-2">
        {state.type === "UserVar" ? "UserVarKey." : "LocationVarKey."}
        {state.key}
      </b>

      <label>VarKey</label>
      <b className="mb-2">
        VarKey.{state.type}
        {state.key}
      </b>
      <label>Type</label>
      <RadioButtons
        className="mb-2"
        options={[
          { value: "UserVar", label: "User Var" },
          { value: "Location", label: "Location" }
        ]}
        value={state.type}
        onOptionSelected={(option) => setState({ ...state, type: option.value } as NewVariableState)}
      />

      <div className="mt-3 flex flex-col gap-2">
        <Input
          label="Key"
          value={state.key}
          placeholder="Key..."
          onChange={(event) => setState({ ...state, key: event.target.value } as NewVariableState)}
          containerClassName="w-full"
        />

        <Input
          label="Display Name"
          value={state.displayName}
          placeholder="Display Name..."
          onChange={(event) => setState({ ...state, displayName: event.target.value } as NewVariableState)}
          containerClassName="w-full"
        />
        <Input
          label="Description"
          value={state.description}
          placeholder="Description...be a good citizen and fill this out."
          onChange={(event) => setState({ ...state, description: event.target.value } as NewVariableState)}
          containerClassName="w-full"
        />
        <Input
          label="Default Value"
          value={state.defaultValue}
          placeholder="Default Value..."
          onChange={(event) => setState({ ...state, defaultValue: event.target.value } as NewVariableState)}
          containerClassName="w-full"
        />

        <div className="flex justify-end gap-2 pt-1">
          <Button variant={ButtonVariant.GHOST} onClick={() => ModalModel.hideModal()}>
            Cancel
          </Button>
          <Button color={ButtonColor.ORANGE} onClick={saveClicked}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};
